import { createSlice } from "@reduxjs/toolkit";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";

export const initialSnipCardReducer = {
    ...new InitialIntegrationReducer(),
};

const snipcartSlice = createSlice({
    name: "Snipcart",
    initialState: { ...initialSnipCardReducer },
    reducers: {
        toggleNewIntegration(state) {
            state.createConfigurationModal = !state.createConfigurationModal;
        },
        toggleDeleteIntegration(state, action) {
            state.configurationToBeDeleted = action.payload;
            state.deleteConfigurationModal = !state.deleteConfigurationModal;
        },
        addNewIntegrationRequest(state) {
            state.submitted = true;
            state.isLoading = true;
            state.createErrorMessage = null;
        },
        addNewIntegrationSuccess(state, action) {
            let config = action.payload;
            let configs = state.configurations;
            if (configs.length > 0) {
                configs = configs.concat(config);
                configs.sort((a, b) =>
                    a.clientName.toLowerCase() > b.clientName.toLowerCase()
                        ? 1
                        : a.clientName.toLowerCase() < b.clientName.toLowerCase
                        ? -1
                        : 0
                );
            } else {
                configs = [config];
            }
            state.submitted = false;
            state.isLoading = false;
            state.createConfigurationModal = false;
            state.configurations = configs;
        },
        addNewIntegrationFailure(state, action) {
            state.submitted = false;
            state.isLoading = false;
            state.createErrorMessage = action.payload;
        },
        getConfigurationsBySelectedOrganizationRequest(state) {
            state.isLoading = true;
            state.configuration = null;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getConfigurationsForSelectedOrganizationSuccess(state, action) {
            state.isLoading = false;
            state.configurations = action.payload;
            state.errorMessage = null;
        },
        getConfigurationsBySelectedOrganizationFailure(state, action) {
            state.isLoading = false;
            state.configurations = null;
            state.errorMessage = action.payload;
        },
        deleteConfigurationRequest(state) {
            state.isDeleteLoading = true;
            state.deleteErrorMessage = null;
        },
        deleteConfigurationSuccess(state) {
            state.configurations = state.configurations.filter((config) => {
                return config.externalUUID !== state.configurationToBeDeleted.externalUUID;
            });
            state.configurationToBeDeleted = null;
            state.deleteConfigurationModal = false;
            state.isDeleteLoading = false;
        },
        deleteConfigurationFailure(state, action) {
            state.isDeleteLoading = false;
            state.deleteErrorMessage = action.errorMessage;
        },
        getConfigurationRequest(state) {
            state.isLoading = true;
            state.configuration = null;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getConfigurationSuccess(state, action) {
            state.isLoading = false;
            state.configuration = action.payload;
            state.errorMessage = null;
        },
        getConfigurationFailure(state, action) {
            state.isLoading = false;
            state.configuration = null;
            state.errorMessage = action.payload;
        },
        setUnsavedChanges(state, action) {
            state.unsavedChanges = action.payload;
        },

        setEditConfiguration(state, action) {
            state.editConfiguration = action.payload;
        },
        updateConfigurationRequest(state) {
            state.isUpdateLoading = true;
            state.configuration = null;
            state.updateErrorMessage = null;
            state.successMessage = null;
        },
        updateConfigurationSuccess(state, action) {
            state.isUpdateLoading = false;
            state.configuration = action.payload;
            state.successMessage = "Speichern erfolgreich.";
            state.advancedSettingsModal = false;
        },
        updateConfigurationFailure(state, action) {
            state.isUpdateLoading = false;
            state.configuration = null;
            state.updateErrorMessage = action.payload;
        },
        triggerSnipcartImportRequest(state) {
            state.importErrorMessage = null;
            state.isImportLoading = true;
            state.importSuccessMessage = "Import gestartet";
        },
        triggerSnipcartImportSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.importErrorMessage = null;
            state.isImportLoading = false;
            state.importSuccessMessage = action.payload.status;
        },
        triggerSnipcartImportFailure(state, action) {
            state.importErrorMessage = action.payload;
            state.isImportLoading = false;
            state.importSuccessMessage = null;
        },
        performSnipcartAccountingImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.successMessage = null;
            state.successMessage = null;
            state.errorMessage = null;
            state.importErrorMessage = null;
        },
        performSnipcartAccountingImportSuccess(state) {
            state.isImportLoading = false;
            state.successMessage =
                "Buchungsstapel wird erzeugt, Du erhältst eine E-Mail wenn der Abruf abgeschlossen ist.";
        },
        performSnipcartAccountingImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload.errorMessage;
        },
        toggleAdvancedSettingsModal(state) {
            state.advancedSettingsModal = !state.advancedSettingsModal;
        },
        resetSuccessMessages(state) {
            state.successMessage = null;
        },
    },
});

export default snipcartSlice;
